import { getAllDataIssues, getDataPathsMetadata } from './globalHelpers';

export const getIssues = (nodes) => {

  let issuesForCurrentTarget = [];

  const flattenIssues = getNonWarningIssuesList();

  
  if (!flattenIssues.length) {
    return [];
  }

  const dataPathsMetadata = getDataPathsMetadata()

  nodes.forEach(node => {
    if (node) {

      const nodeTypeName = getNodeTypeNameFrom(dataPathsMetadata, node)
      const showTargetAndChildrenIssues = canShowTargetAndChildrenIssues(nodeTypeName);

      if (targetHasIssues(node.path, flattenIssues) || showTargetAndChildrenIssues) {
        issuesForCurrentTarget.push(
          ...getIssuesForTargetAndChildren(node.path, flattenIssues)
        );
      }
    }
  });

  return getUniqueIssues(issuesForCurrentTarget);
};

const isTile = (nodeTypeName) => {
  return nodeTypeName === "ContentfulProductTile"
};

const isImage = (nodeTypeName) => {
  return nodeTypeName === "ContentfulCloudinaryImageComponent"
};

const isUniversalContentModel = (nodeTypeName) => {
  return nodeTypeName === "ContentfulUniversalContentModel"
};

const isTab = (nodeTypeName) => {
  return nodeTypeName === "ContentfulTabFaqs"
  || nodeTypeName === "ContentfulTabFinishingOptions"
  || nodeTypeName === "ContentfulTabOverview"
  || nodeTypeName === "ContentfulTabMarkdown"
};

function canShowTargetAndChildrenIssues(nodeTypeName) {
  return isTile(nodeTypeName) 
  || isImage(nodeTypeName)
  || isTab(nodeTypeName)
  || isUniversalContentModel(nodeTypeName);
}

function getNodeTypeNameFrom(dataPathsMetadata, node) {
  return (dataPathsMetadata[node.path] || {}).__typename 
  || (dataPathsMetadata[node.parentPath] || {}).__typename;
}

const targetHasIssues = (targetPath, issues) => {
  if (!targetPath) {
    return [];
  }

  return issues.find((issue) => issue.firstPathWithNonPrimitiveValue === targetPath || issue.path === targetPath);
};

function getIssuesForTargetAndChildren(targetNodePath, issues) {
  if (!targetNodePath) {
    return [];
  }

  return issues.filter((issue) => issue.path.startsWith(targetNodePath));
}

function getNonWarningIssuesList() {
  const flattenIssues = [];
  const allDataIssues = getAllDataIssues();
  for (const group in allDataIssues) {
    if (group === 'warning') {
      continue;
    }
    flattenIssues.push(...allDataIssues[group]);
  }

  return flattenIssues;
}

function getUniqueIssues(issues) {
  if (!issues.length) {
    return issues;
  }

  return [
    ...new Set(
      issues.map((issue) => JSON.stringify({
        message: issue.message,
        whereToFixLink: issue.whereToFixLink,
        howToFixLink: issue.howToFixLink,
      })
      )
    ),
  ].map(JSON.parse);
}
